import * as React from "react";

import { cn } from "./utils";

function Badge({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border border-transparent px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none",
        className,
      )}
      {...props}
    />
  );
}

export { Badge };
